<div class="drawer-section">
  <button
    type="button"
    class="drawer-header"
    (click)="toggle()"
    [attr.aria-expanded]="expanded"
  >
    <span class="drawer-title">{{ title }}</span>
    <mat-icon class="chevron" [class.collapsed]="!expanded"
      >expand_less</mat-icon
    >
  </button>
  @if (expanded) {
    <nav>
      <ul>
        @for (link of navList; track link.name) {
          <li>
            <a
              class="nav-item"
              [routerLink]="link.path"
              routerLinkActive="active"
              #rla="routerLinkActive"
              [attr.aria-current]="rla.isActive ? 'page' : null"
              (click)="linkClick.emit()"
            >
              <span class="nav-text">{{ link.name }}</span>
            </a>
          </li>
        }
      </ul>
    </nav>
  }
</div>
